import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import doneImg from "../../assets/images/successfully-done.svg";
import SignUpNavbar from "../../components/SignUpNavbar";
import { useAuth } from "../../context/AuthContext";

/**
 * Final onboarding screen, shown once the user has set their password (the last
 * data step). Purely celebratory — its single CTA takes the user to the
 * dashboard, where the remaining setup tasks (profile photo first) are listed.
 */
const OnboardingSuccess = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const firstName = user?.firstname?.trim();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <SignUpNavbar />
      <div className="flex items-center justify-center p-20 px-4 md:px-10">
        <div className="flex items-center flex-col gap-10">
          <img src={doneImg} alt="Welcome to Visaro" />
          <div className="flex flex-col justify-center items-center gap-8">
            <div className="flex flex-col items-center gap-3">
              <div className="text-4xl md:text-3xl lg:text-5xl max-w-3xl font-bold text-center">
                {firstName ? `Welcome to Visaro, ${firstName}!` : "Welcome to Visaro!"}
              </div>
              <div className="text-gray-500 text-center max-w-lg">
                Your account is ready. Fund your wallet to book flights straight
                away, and finish setting up your account on the dashboard to
                unlock paying in installments.
              </div>
            </div>
            <div className="flex flex-col gap-2 max-w-md w-full">
              <button
                type="button"
                onClick={() => navigate("/home", { replace: true })}
                className="p-4 px-5 w-full text-center border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingSuccess;
